<template>
  <div>
    <b-card>
      <b-row>
        <b-col
          cols="12"
          md="4"
        >
          <bank-select />
        </b-col>
        <b-col
          cols="12"
          md="4"
        >
          <card-organization />
        </b-col>
        <b-col
          cols="12"
          md="4"
        >
          <card-type />
        </b-col>
        <b-col>
          <bin-no />
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>
<script>
import { BCard, BRow, BCol } from 'bootstrap-vue'
import BinNo from '@/views/Bins/elements/BinNo.vue'
import BankSelect from '@/views/Bins/elements/BankSelect.vue'
import CardOrganization from '@/views/Bins/elements/CardOrganization.vue'
import CardType from '@/views/Bins/elements/CardType.vue'

export default {
  name: 'ItemForm',
  components: {
    BCard,
    BRow,
    BCol,
    BinNo,
    BankSelect,
    CardOrganization,
    CardType,
  },
}
</script>
